// Generated types for SysMLClassifier
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLTypeReadAPI, SysMLTypeWriteAPI } from './sysmltype';
import { SysMLTypeReadAPISchemaObject, SysMLTypeWriteAPISchemaObject } from './sysmltype';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLClassifierReadAPI extends SysMLTypeReadAPI {
}

export interface SysMLClassifierWriteAPI extends SysMLTypeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLClassifierReadAPISchemaObject = SysMLTypeReadAPISchemaObject.extend({}).passthrough();
export const SysMLClassifierReadAPISchema: z.ZodType<SysMLClassifierReadAPI> = SysMLClassifierReadAPISchemaObject;

export const SysMLClassifierWriteAPISchemaObject = SysMLTypeWriteAPISchemaObject.extend({}).passthrough();
export const SysMLClassifierWriteAPISchema: z.ZodType<SysMLClassifierWriteAPI> = SysMLClassifierWriteAPISchemaObject;
